module.exports = __webpack_public_path__ + "img/image-4.6cfd95d6.png";